import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ADMIN_KEY = "admin_key";

export const getAdminKey = () => sessionStorage.getItem(ADMIN_KEY) || "";
export const setAdminKey = (k) => (k ? sessionStorage.setItem(ADMIN_KEY, k) : sessionStorage.removeItem(ADMIN_KEY));
const adminHeaders = (k = getAdminKey()) => ({ headers: { "X-Admin-Key": k } });

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d[0]?.loc?.includes("email") ? "Please enter a valid email address." : fallback;
  return typeof d === "string" ? d : fallback;
};

export const submitContact = (data) => axios.post(`${API}/contact`, data).then((r) => r.data);
export const submitQuote = (data) => axios.post(`${API}/quotes`, data).then((r) => r.data);

export const verifyAdmin = (k) => axios.post(`${API}/admin/verify`, {}, adminHeaders(k)).then((r) => r.data);
export const fetchLeads = (params) => axios.get(`${API}/admin/leads`, { params, ...adminHeaders() }).then((r) => r.data);
export const updateLeadStatus = (id, status) => axios.patch(`${API}/admin/leads/${id}`, { status }, adminHeaders()).then((r) => r.data);
export const deleteLead = (id) => axios.delete(`${API}/admin/leads/${id}`, adminHeaders()).then((r) => r.data);
